const createCssVar = (name: string, value: any) => {
    if (name[0] !== '-') name = '--' + name
    if (value) document.documentElement.style.setProperty(name, value)
    return getComputedStyle(document.documentElement).getPropertyValue(name)
}

export default createCssVar